export default __webpack_public_path__ + "static/media/sparkle.a08771a3.svg";